import { useEffect, useRef, useState } from "react";

const OutsideClickDetector = () => {
  const containerRef = useRef(null); // Ref for the container of the exam area
  const [, setOpenWarning] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click was outside the container area
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpenWarning(true); // Show warning message
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    null
  );
};

export default OutsideClickDetector;